<div *ngIf="!checkoutInitiated && showCheckoutSummary" id="cart-summary" class="subBlockContainer entry-loader">
    <!-- <div id="cart-summary" class="subBlockContainer entry-loader"> -->
    <child-header #childHeader [title]="cartName" [titleIcon]="(cartItems?.length == 1? !commonService.isEmpty(cartItems[0]) : cartItems?.length) && (newCartStatus == 3) ? 'share' : ''" (closeEvent)="navigateTo('/myCarts')">
    </child-header>
    <div class="mat-toolbar-menu">
        <button mat-button (click)="open(changeCartNameContainer, $event)"><i class="basic-icon edit-icon"></i> Rename Cart</button>
        <button mat-button (click)="cloneCart(cartId)"><i class="basic-icon shoppingcart-icon"></i> Clone Cart</button>
        <button *ngIf="showDeleteButton && (selectedCartLoginId==loginId)" mat-button (click)="deleteShoppingCart(cartId)"><i class="basic-icon delete-icon"></i> Delete Cart</button>
        <ng-container *ngIf="currentUserModel?.source!='SAP'">
            <div class="mat-slide-wrapper">
                <mat-slide-toggle [checked]="(cartItems.length > 1 && !commonService.isEmpty(cartItems[0]) && (newCartStatus == 3))" (click)="shareCart()">Share with my company</mat-slide-toggle>
            </div>
            <button mat-button (click)="open(sendtoSalesContainer, $event)"><i class="basic-icon sale-icon"></i> Send cart to Dicker Data Sales</button>
            <button mat-button (click)="downloadCartToExcel()"><i class="basic-icon download-icon"></i> Download to excel</button>
            <button mat-button (click)="open(uploadContainer, $event)"><i class="basic-icon upload-icon"></i> Upload stock codes</button>
        </ng-container>
    </div>
    <div class="subBlockContent">
        <div *ngIf="loadContent" class="inner-subBlock-wrapper">
            <div class="cartBar page-title-wrapper" style="display: none;">
                <div [class.cart-title]="newCartStatus && newCartStatus == 3" class="page-title-position">
                    <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/myCarts']">close</i>
                    <div class="cart-title-content">
                        <img alt="" *ngIf="(cartItems?.length == 1? !commonService.isEmpty(cartItems[0]) :cartItems?.length) && (newCartStatus == 3)" src="/images/new_ui/globalShoppingCartActive.png">
                    </div>
                    <div class="title blade-title-font float-left margin-r-x10" *ngIf="editCartId != cartId">{{cartName}}</div>

                    <span style="display: inline-block;"></span>

                    <ng-container *ngIf="currentUserModel?.source!='SAP'">

                        <!-- Edit Cart Popup -->
                        <div id="editCartNamePopup">
                            <input #editCartId class="edit-input" type="text" [value]="cartName" [(ngModel)]="editCartName" (input)="validateCartName($event)" (keyup.enter)="confirmCartNameValue(editCartId.value, cartId)" *ngIf="editCartId == cartId">
                            <button class="button button-red button-mid" (click)="confirmCartNameValue(editCartId, cartId)" *ngIf="editCartId == cartId">Ok</button>
                            <button class="button button-red button-mid" (click)="setEditCart('0')" *ngIf="editCartId == cartId">Cancel</button>
                        </div>

                        <!-- Edit Cart Button -->
                        <span id="edit-icon" class="basic-icon edit-icon" *ngIf="editCartId != cartId" ngbTooltip="Rename Cart" placement="bottom" (click)="setEditCart(cartId)"></span>

                        <!-- Check Out Button -->
                        <span id="shoppingcart-icon" class="basic-icon shoppingcart-icon" [style.display]="!cartItems?.length?'none':'inline-block'" (click)="cloneCart(cartId)" ngbTooltip="Clone Cart" placement="bottom"></span>

                        <!-- Delete Cart Button -->
                        <span *ngIf="showDeleteButton && (selectedCartLoginId==loginId)" id="delete-icon" class="basic-icon delete-icon" (click)="deleteShoppingCart(cartId)" ngbTooltip="Delete Cart" placement="bottom"></span>

                    </ng-container>

                </div>
            </div>
            <div id="share-cartBar" class="filter-wrapper">
                <!-- TODO: delete filterCartItems and use shared pipe instead -->

                <div class="flex-item searchInputGroup-margin">
                    <div class="searchInputGroup">
                        <div class="searchIcon">
                            <img src="../images/new_ui/filter.png">
                        </div>
                        <input #searchInput class="searchInput" type="text" [(ngModel)]="searchFilter" placeholder="Filter" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Filter'" (ngModelChange)="filterCartItems()">
                    </div>
                </div>

                <div class="col-md-3 listpart select-out-wrapper">
                    <ng-select
                        [items]="locations"
                        bindValue="value"
                        bindLabel="name"
                        placeholder="Delivery / Pick Up"
                        (change)="changeShippingMethod()"
                        [formControl]="shippingMethodControl"
                    >
                    </ng-select>
                </div>

                <!-- <ng-container *ngIf="currentUserModel?.source!='SAP'"> -->

                <!-- share with my company -->
                <!-- <div class="flex-item" [class.sliderclicked]="((cartItems?.length == 1?cartItems[0]:cartItems?.length) && (newCartStatus == 3))" (click)="shareCart()">
                        <span *ngIf="cartItems?.length == 1?cartItems[0]:cartItems?.length" class="slider round" id="share-slider"></span>
                        <p *ngIf="(cartItems?.length == 1?cartItems[0]:cartItems?.length) && (newCartStatus == 0)" ngbTooltip="Share with my company" placement="bottom">Share with my company</p>
                        <p *ngIf="(cartItems?.length == 1?cartItems[0]:cartItems?.length) && (newCartStatus == 3)" ngbTooltip="Unshare with my company" placement="bottom">Share with my company</p>
                    </div> -->
                <!-- Send cart to Dicker Data Sales -->
                <!-- [routerLink]="['sendtosales']" -->
                <!-- <div class="flex-item" *ngIf="cartItems?.length == 1?cartItems[0]:cartItems?.length" (click)="open(sendtoSalesContainer, $event)">
                        <span id="sales"></span>
                        <p ngbTooltip="Send cart to Dicker Data Sales" placement="bottom">Send cart to Dicker Data Sales</p>
                    </div> -->
                <!-- Download -->
                <!-- <div class="flex-item" *ngIf="cartItems?.length == 1?cartItems[0]:cartItems?.length" (click)="downloadCartToExcel()">
                        <span id="download"></span>
                        <p ngbTooltip="Download to excel" placement="bottom">Download to excel</p>
                    </div> -->
                <!-- Upload -->
                <!-- [routerLink]="['upload']" -->
                <!-- <div class="flex-item" (click)="open(uploadContainer, $event)">
                        <span id="upload"></span>
                        <p ngbTooltip="Upload stock codes" placement="bottom">Upload stock codes</p>
                    </div> -->
                <!-- </ng-container> -->

            </div>

            <div class="table-wrapper table-header-allign">
                <table id="cartTable" matSort (matSortChange)="sortData($event)" class="white">
                    <thead>
                        <tr class="row cart-title-wrapper">
                            <th style="padding-left: 15px" [style.width]="currentUserModel?.hideSOH ? '68%' : '60%'" mat-sort-header="description">DESCRIPTION</th>
                            <th style="width: 8%" mat-sort-header="soh" [class.col-hide]="currentUserModel?.hideSOH">SOH</th>
                            <th style="width: 5%" mat-sort-header="qty">QTY</th>
                            <th style="width: 12%;padding-left: 32px;" mat-sort-header="price">PRICE</th>
                            <th style="width: 10%;padding-left: 14px;" mat-sort-header="subtotal">SUBTOTAL</th>
                            <th style="width: 5%"></th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div class="table-wrapper child-body">
                <table id="cartTable" matSort (matSortChange)="sortData($event)" class="white">
                    <thead hidden="true">
                        <tr class="row cart-title-wrapper">
                            <th style="padding-left: 15px" [style.width]="currentUserModel?.hideSOH ? '68%' : '60%'" mat-sort-header="description">DESCRIPTION</th>
                            <th style="width: 8%" mat-sort-header="soh" [class.col-hide]="currentUserModel?.hideSOH">SOH</th>
                            <th style="width: 5%" mat-sort-header="qty">QTY</th>
                            <th style="width: 12%;padding-left: 32px;" mat-sort-header="price">PRICE</th>
                            <th style="width: 10%;padding-left: 14px;" mat-sort-header="subtotal">SUBTOTAL</th>
                            <th style="width: 5%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="row product-wrapper product-content-wrapper {{ci?.backgroundClass}}" *ngFor="let ci of sortedData; let idx = index">
                            <!-- Description -->
                            <div *ngIf="ci.stockCode.toLowerCase() != 'donation'" style="padding-left: 15px" [style.width]="currentUserModel.hideSOH ? '65%' : '57%'">
                                <a routerLink='./product/{{ci?.stockCode}}' (click)="checkProductDetail(ci?.stockCode)">
                                    <div class="result_desc">{{ci?.itemDescription}}</div>
                                    <div >
                                        <div class="produc-secondary-title-wrapper">
                                            <span class="light-text">BRAND:&nbsp;</span>
                                            <span>{{ci?.itemDescription.split(' ')[0]}}</span>
                                            <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                            <span class="light-text">STATUS:&nbsp;</span>
                                            <span>{{ci.status}}</span>
                                            <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                            <span class="light-text">SKU:&nbsp;</span>
                                            <span>{{ci?.stockCode}}</span>
                                            <span class="divider-wrapper" *ngIf="ci?.rrp">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                            <span class="light-text" *ngIf="ci?.rrp">RRP:&nbsp;</span>
                                            <span *ngIf="ci?.rrp">{{ci?.rrp | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                                            <div *ngFor="let product of productDetailArray">
                                                <span *ngIf="product?.mainProduct?.stockCode==ci?.stockCode">
                                                    <span *ngIf="product?.mainProduct?.promoFinish && product?.mainProduct?.promoFinish !== null">
                                                        <img class="center" src="../images/new_ui/promotion.png">
                                                        <span class="bold-text center">PROMOTION:</span> <span class="light-text center">ENDS
                                                        ON {{product?.mainProduct?.promoFinish}}</span>
                                                </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div *ngIf="ci.stockCode.toLowerCase() == 'donation'" style="padding-left: 15px" [style.width]="'65%'">
                                <div class="result_desc">{{ci?.itemDescription}} FOR {{ currentUserModel.isAU ? 'FNPW' : 'TREE THAT COUNT' }}</div>
                                <div style="font-size: 12px;">
                                    <span >
                                      On behalf of Dicker Data and {{ currentUserModel.isAU ? 'FNPW' : 'TTC' }} thank you for your contribution to our bushfire recovery initiative
                                    </span>
                                    <div class="result-additional-info">
                                        <div class="promotion-wrapper text-font" row>
                                            <img class="center" style="height: 14px;" src="../images/new_ui/donation.png">
                                            <div class="bold-text center" style="display: inline-block; margin-left: 2px;">DONATION</div>
                                        </div>
                                     </div>
                                </div>
                            </div>
                            <!-- SOH -->
                            <div *ngIf="ci?.stockCode?.toLowerCase() != 'donation'" style="width: 8%; padding-left: 7px;text-align: center;margin-top:auto;margin-bottom:auto" [class.col-hide]="currentUserModel.hideSOH">
                                <div [ngStyle]="{'margin-bottom': isPickUp ? '12px' : '0px'}">
                                    <span *ngIf="ci?.freightPolicy?.toString() == 'E'" class="master-tooltip align-right" title="ELECTRONIC">
                                        {{ci.freightPolicy}}
                                    </span>
                                    <span *ngIf="ci?.freightPolicy?.toString() == 'L'" class="master-tooltip align-right" title="LABOUR">
                                        {{ci.freightPolicy}}
                                    </span>
                                    <span *ngIf="ci?.freightPolicy != 'L' && ci?.freightPolicy != 'E'" class="align-right">
                                       {{sohLoad(ci)}}
                                    </span>
                                </div>
                                <div style="height: 18px;" *ngIf="isPickUp && ci?.freightPolicy != 'E'">
                                    <span style="display: inline-block; width: 174px;">{{ci?.branch_AvailStock}} available to pick up </span>
                                </div>
                            </div>
                            <!-- qty -->
                            <div style="width: 5%;padding-left: 20px;position: relative;margin-top:auto;margin-bottom:auto">
                                <div *ngIf="ci?.stockCode?.toLowerCase() != 'donation'" [ngStyle]="{'margin-bottom': isPickUp ? '12px' : '0px'}">
                                    <span *ngIf="ci?.salesType == 'MR' && ci?.maxQty">
                                        <mat-icon class="usernameicon align-right" placement="bottom"
                                            ngbTooltip="Maximum order quantity is {{ci?.maxQty | number}}">info</mat-icon>
                                    </span>
                                    <span *ngIf="ci?.salesType == 'MR' && (!ci?.maxQty && ci?.minQty)">
                                        <mat-icon class="usernameicon align-right" placement="bottom"
                                            ngbTooltip="Minimum order quantity is {{ci?.minQty | number}}">info</mat-icon>
                                    </span>
                                    <input *ngIf="ci?.salesType == 'MR'" class="qtyInput{{ci?.cartItemID}} input-wrapper input-wrapper-small align-center input-size" type="number" min="{{ci.minQty | number}}" max="{{ci.maxQty | number}}" [(ngModel)]="ci.quantity" (keypress)="isNumberKey($event)"
                                        (blur)="updateItemQty(ci, idx)" (click)="noRedirect($event)" [disabled]="isAnnuityCart">
                                    <input *ngIf="ci?.salesType != 'MR'" class="qtyInput{{ci?.cartItemID}} input-wrapper input-wrapper-small align-center" type="number" [(ngModel)]="ci.quantity" (keypress)="isNumberKey($event)" (blur)="updateItemQty(ci, idx)" (click)="noRedirect($event)"
                                        [disabled]="isAnnuityCart">
                                </div>
                                <div *ngIf="ci?.stockCode?.toLowerCase() == 'donation'" style="padding-left: 18px;">
                                    <span class="align-right" type="number">
                                        {{ci?.quantity}}
                                    </span>
                                </div>
                                <div style="height: 18px;" *ngIf="isPickUp && ci?.freightPolicy != 'E'">
                                    <span></span>
                                </div> 
                            </div>
                            <!-- price -->
                            <div class="align-right" style="width: 10%;margin-top:auto;margin-bottom:auto">
                                <div [ngStyle]="{'margin-bottom': isPickUp ? '12px' : '0px'}">
                                    <span>
                                        <ng-container *ngIf="ci?.billingFrequency=='1'">
                                            {{ci?.unitCost | currency:'AUD':'symbol-narrow':'.2-2'}}/mth
                                        </ng-container>
                                        <ng-container *ngIf="ci?.billingFrequency=='Y'">
                                            {{ci?.unitCost | currency:'AUD':'symbol-narrow':'.2-2'}}/year
                                        </ng-container>
                                        <ng-container *ngIf="ci?.billingFrequency!=='Y' && ci?.billingFrequency!=='1'">
                                            {{ci?.unitCost | currency:'AUD':'symbol-narrow':'.2-2'}}
                                        </ng-container>
                                     </span>
                                </div>
                                <div style="height: 18px;" *ngIf="isPickUp && ci?.freightPolicy != 'E'">
                                </div> 
                            </div>
                            <!-- sub total -->
                            <div class="align-right" style="width: 10%;padding-right: 10px;margin-left: 30px;margin-top:auto;margin-bottom:auto">
                                <div [ngStyle]="{'margin-bottom': isPickUp ? '12px' : '0px'}">
                                    <span>{{ci?.subTotal | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                                </div>
                                <div style="height: 18px;" *ngIf="isPickUp && ci?.freightPolicy != 'E'">
                                    <span></span>
                                </div> 
                            </div>
                            <!-- delete icon -->
                            <div style="width: 5%;position: relative;padding-left: 10px;margin-top:auto;margin-bottom:auto">
                                <span [id]="ci?.cartItemID" class="basic-icon delete-icon {{ci?.backgroundClass}} center-text" style="width: 23px; height: 23px; transform: translate(-50%, -70%);" (click)="deleteItem($event, ci)"></span>
                            </div>

                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="table-footer-wrapper">
                <table>
                    <tfoot>
                        <tr class="row totalPrice-wrapper">
                            <ng-container *ngIf="cartItems?.length == 1 ? !commonService.isEmpty(cartItems[0]) : cartItems?.length">
                                <div class="col-md align-right bold-text offset-md-7">TOTAL ex GST</div>
                                <div class="col-md align-right price">
                                    <span>{{totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                                </div>
                            </ng-container>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <ng-container *ngIf="currentUserModel?.source!='SAP'">

                <div class="checkout-button-wrapper">
                    <section>
                        <button class="button button-red button-large check-out-finance" style="margin-right: 15px;" [disabled]="!cartItems?.length" (click)="goToFinance()" *ngIf="currentUserModel?.isAU && currentUserModel?.hasPurchaseAccess">Finance Quote</button>
                        <button class="button button-internal button-large check-out-quote" style="margin-right: 15px;" [disabled]="!cartItems?.length" (click)="createQuote()" *ngIf="currentUserModel?.isStaffAccount">Convert To Quote</button>
                        <button class="button button-red button-large check-out" [disabled]="!cartItems?.length" (click)="checkOutCart()" *ngIf="currentUserModel?.hasPurchaseAccess">Checkout</button>
                    </section>
                </div>
            </ng-container>

            <ng-container *ngIf="currentUserModel?.source==='SAP'">
                <div class="checkout-button-wrapper">
                    <section>
                        <button class="button button-red button-large check-out-finance" style="margin-right: 15px;" [disabled]="!cartItems?.length" (click)="punchOut()" *ngIf="currentUserModel?.isAU">PUNCHOUT </button>
                    </section>
                </div>
            </ng-container>
        </div>

        <div class="description row" *ngIf="loadContent" >
            <div style="width: 16%; align-items: center; display: flex;">
                <div>
                    <img *ngIf="currentUserModel?.isAU" class="center" src="../images/site-icons/FNPW_Primary_Logo_RGB.svg">
                    <img *ngIf="!currentUserModel?.isAU" class="center" src="../images/site-icons/logos_ttc_logo_v3.svg">
                </div>
            </div>
            <div style="width: 57%; align-items: center; display: flex;">
                <div>
                    <div>
                        <span style="font-size: 12px;">
                            {{ currentUserModel?.isAU ? 'Dicker Data supports the Fundation for National Parks and Wildlife.' : 'Dicker Data supports Trees That Counts.' }}
                        </span>
                    </div>
                    <div>
                        <span style="font-size: 12px; font-weight: bold;">
                            Make a donation today and we'll match it, dollar for dollar!*
                        </span>
                    </div>
                    <div>
                        <span style="margin: 5px 0px 5px 0px; font-size: 10px; line-height: 11px; display: block;">
                            {{ 
                                currentUserModel?.isAU ? 
                                "The Foundation for National Parks and Wildlife (FNPW) is the charity partner of Australia's national parks, ensuring that Australia's wilderness and wildlife are conserved for future generations. To learn more about our partnership with FNPW, visit: " :
                                "By donating to Trees That Count, you're donating native trees and taking tangible action for our local environment. Your support help grow incredible, future-focused restoration projects across Aotearoa. To learn more about our partnership with Trees That Count, visit: " 
                            }}
                            
                            <a [href]="'https://www.dickerdata.' + (currentUserModel?.isAU ? 'com.au/fnpw' : 'co.nz/treethatcount')" target="_blank" style="text-decoration:none">
                                <span style="color: #C20047;">
                                    {{currentUserModel?.isAU ? 'https://www.dickerdata.com.au/fnpw' : 'https://www.dickerdata.co.nz/treethatcount'}}
                                </span>
                            </a>
                        </span>
                    </div>
                    <div>
                        <span style="font-size: 9px; color: #808080">
                            *Donations over $2 are tax deductible. Dicker Data will match the first $10,000 donated by reseller partners.
                        </span>
                    </div>
                </div>
            </div>
            <div style="width: 27%; align-items: center; display: flex;">
                <div class="div-donate">
                    <div class="donation-container">
                      <ng-container *ngFor="let item of donationOptionsList">
                        <div class="donation-item" [class.active]="selectedDonationValue == item.value" (click)="clickDonation(item.value)">
                            <div class="donation-content">
                              <b>DONATE</b><br/>
                              <span class="donation-value" >${{ item.value }}</span>
                            </div>
                        </div>
                      </ng-container>
                    </div>
                </div>
            </div>
        </div>


        <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>
    </div>

    <ng-template #sendtoSalesContainer let-c="close" let-d="dismiss">
        <child-header title="Send Cart To Dicker Data Sales" (closeEvent)="d('Cross click')"></child-header>
        <app-send-cart-to-sales (notify)='closePopup($event)'></app-send-cart-to-sales>
    </ng-template>

    <ng-template #uploadContainer let-c="close" let-d="dismiss">
        <child-header title="Upload Stock Codes" (closeEvent)="d('Cross click')"></child-header>
        <app-upload-to-cart (notify)='closePopup($event)'></app-upload-to-cart>
    </ng-template>
</div>

<ng-template #changeCartNameContainer let-c="close" let-d="dismiss">
    <div class="shopping-cart-modal shopping-cart-size">
        <child-header title="Cart Name" (closeEvent)="d('Cross click')"></child-header>
        <div class="modal-body">
            <input class="cart-name-modal pop-up-black-text col-md-12" [value]="cartName" #editCartShopCartName type="text" (keyup.enter)="confirmCartNameValue(editCartShopCartName.value, cartId); d('Cross click')">

            <div class="save-button-position">
                <section>
                    <button type="button" class="button button-red button-large" (click)="confirmCartNameValue(editCartShopCartName.value, cartId)" (click)="d('Cross click')">Update cart</button>
                </section>
            </div>

        </div>
    </div>
</ng-template>

<!-- When the end user click the checkout button, hide the cart details -->
<div *ngIf="checkoutInitiated">
</div>

<router-outlet></router-outlet>